module.exports = __webpack_public_path__ + "img/back3.c5263fb9.png";